import { createSpyObj } from 'jest-createspyobj';

export function ifAutoPlaytest(cb) {
  if (navigator.userAgent === 'playtester-puppeteer') {
    cb();
  }
}

export function createFakeMap({ width = 20, height = 20 } = {}) {
  const map = Object.assign(
    createSpyObj('Map', [
      'worldToTileX',
      'worldToTileY',
      'getTileAt',
      'fill',
      'putTileAt'
    ]),
    { width, height }
  );

  map.putTileAt.mockReturnValue(createSpyObj('Tile', ['setAlpha']));
  map.getTileAt.mockReturnValue(createSpyObj('Tile', ['index', 'x', 'y']));

  return map;
}

export function createFakeScene({ key = 'WorldScene', pieces = [] } = {}) {
  const sceneAddMethods = ['sprite', 'setDepth', 'setOrigin', 'destroy'];

  const scene = Object.assign(
    createSpyObj('Scene', ['animateDeath', 'showHitPointsUI']),
    {
      map: createFakeMap(),
      add: Object.assign(createSpyObj('SceneAdd', sceneAddMethods), {
        anims: createSpyObj('Anims', ['load', 'play'])
      }),
      key,
      captured: { blue: [], red: [] },
      scene: { key, get: () => ({ turnNumber: 0 }) },
      game: {
        registry: createSpyObj('Registry', ['get']),
        soundManager: {
          playSfx: jest.fn()
        }
      },
      pieces: createSpyObj('Pieces', ['getChildren'])
    }
  );
  scene.pieces.getChildren.mockReturnValue(pieces);
  scene.animateDeath.mockImplementation(
    (madeKill, hitRed, pieceTile, bounceback, cb) => cb()
  );

  sceneAddMethods.forEach(method =>
    scene.add[method].mockReturnValue(scene.add)
  );

  scene.add.on = jest.fn((_animKey, cb) => cb());

  return scene;
}
